<template>
    <header class="header-wrap" :class="{ 'is-profile': isProfile }">
        <loading v-show="isLoading"></loading>

        <nav class="navigation" v-if="isDesktop">
            <router-link class="logo flex" :to="{ name: 'exchanger' }" tag="div"> Ex-Bank</router-link>

            <div class="flex">
                <router-link class="navigation-item" :to="{ name: 'agreement' }" tag="div">{{ $t("header.termsOfUse") }}</router-link>
                <router-link class="navigation-item" :to="{ name: 'aml-kyc' }" tag="div">{{ $t("header.amlkyc") }}</router-link>
                <!-- <router-link class="navigation-item" :to="{ name: 'news' }" tag="div"> {{ $t("header.news") }} </router-link> -->
                <!-- <router-link class="navigation-item" :to="{ name: 'faq' }" tag="div">{{ $t("header.faq") }}</router-link> -->
                <router-link class="navigation-item" :to="{ name: 'partners' }" tag="div">{{ $t("header.partnership") }}</router-link>
                <router-link class="navigation-item" :to="{ name: 'contacts' }" tag="div">{{ $t("header.contacts") }}</router-link>
                <router-link class="navigation-item" :to="{ name: 'acquiring' }" tag="div">{{ $t("header.acquiring") }}</router-link>

            </div>
            <div class="spacer"></div>

            <LangSwithcer />

            <div class="navigation-sign">
                <div class="flex" @click.stop="openAuth('signIn')" v-if="!isAuthenticated">
                    <!-- <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="2 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                    </div> -->
                    <div class="sign-name">{{ $t("header.login") }}</div>
                    <!-- <my-button class="header-" outline :value="$t('header.login')"></my-button> -->
                </div>
            </div>
            <div v-if="!isAuthenticated" class="slang">
                {{ $t("header.authOr") }}
            </div>
            <div @click.stop="changeView('signUp'), openAuth('signUp')">
                <my-button :value="$t('header.reg')" v-if="!isAuthenticated"></my-button>
            </div>

            <router-link class="navigation-user" :to="{ name: 'profile', params: { view: 'orders' } }" tag="div" :title="$t('header.myProfile')" v-if="isAuthenticated && isUser">
                <div class="avatar">
                    {{ firstChar }}
                </div>

                <div class="user-name">{{ userName }}</div>
            </router-link>
        </nav>

        <nav class="navigation" v-if="!isDesktop">
            <router-link class="logo" :to="{ name: 'exchanger' }" tag="div"> Ex-Bank</router-link>

            <div class="spacer"></div>
            <LangSwithcer />

            <div class="icon-hamburger" @click.stop="toggleMobileMenu">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu">
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </div>
        </nav>

        <div class="navigation-profile-wrap" v-if="isProfile">
            <nav class="navigation-profile">
                <router-link class="navigation-profile-item" :to="{ name: 'profile', params: { view: 'orders' } }" tag="div">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="2 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="feather feather-repeat">
                            <polyline points="17 1 21 5 17 9"></polyline>
                            <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                            <polyline points="7 23 3 19 7 15"></polyline>
                            <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                        </svg>
                    </div>
                    <div>{{ $t("header.myOrders") }}</div>
                </router-link>

                <router-link class="navigation-profile-item" :to="{ name: 'profile', params: { view: 'cards' } }" tag="div">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="feather feather-credit-card">
                            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                            <line x1="1" y1="10" x2="23" y2="10"></line>
                        </svg>
                    </div>
                    <div>{{ $t("header.myCards") }}</div>
                </router-link>

                <router-link class="navigation-profile-item" :to="{ name: 'profile', params: { view: 'referral' } }" tag="div">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="feather feather-users">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                    </div>
                    <div>
                        {{ $t("header.referralProgram") }}
                    </div>
                </router-link>

                <!-- <router-link class="navigation-profile-item" :to="{ name: 'profile', params: { view: 'discount' } }" tag="div">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.4" viewBox="0 0 209.281 209.281" xml:space="preserve">
                        <g>
                            <path
                                d="M207.17,99.424l-20.683-21.377l4.168-29.455c0.567-4.006-2.145-7.739-6.131-8.438l-29.298-5.137L141.285,8.739
		c-1.896-3.575-6.287-4.998-9.919-3.223L104.64,18.582L77.916,5.517c-3.636-1.777-8.023-0.351-9.92,3.223L54.055,35.018
		l-29.298,5.137c-3.985,0.698-6.698,4.432-6.131,8.438l4.167,29.455L2.11,99.424c-2.813,2.907-2.813,7.522,0,10.43l20.682,21.378
		l-4.167,29.456c-0.566,4.005,2.146,7.738,6.13,8.438l29.299,5.14l13.942,26.275c1.896,3.574,6.284,5,9.919,3.223l26.724-13.062
		l26.727,13.062c1.059,0.518,2.181,0.763,3.288,0.763c2.691,0,5.286-1.454,6.63-3.986l13.942-26.275l29.299-5.14
		c3.984-0.699,6.697-4.433,6.13-8.438l-4.168-29.456l20.684-21.378C209.984,106.946,209.984,102.332,207.17,99.424z
		 M173.158,123.438c-1.608,1.662-2.359,3.975-2.035,6.266l3.665,25.902l-25.764,4.52c-2.278,0.4-4.245,1.829-5.329,3.872
		l-12.26,23.105l-23.502-11.486c-1.039-0.508-2.166-0.762-3.294-0.762c-1.127,0-2.254,0.254-3.293,0.762l-23.5,11.486l-12.26-23.105
		c-1.084-2.043-3.051-3.472-5.329-3.872l-25.764-4.52l3.664-25.902c0.324-2.29-0.427-4.603-2.036-6.265l-18.186-18.799
		l18.186-18.797c1.608-1.662,2.36-3.975,2.036-6.265l-3.664-25.901l25.763-4.517c2.279-0.399,4.246-1.829,5.331-3.872l12.259-23.108
		l23.499,11.489c2.078,1.017,4.508,1.017,6.588,0l23.501-11.489l12.26,23.108c1.084,2.043,3.051,3.473,5.33,3.872l25.763,4.517
		l-3.665,25.901c-0.324,2.291,0.427,4.603,2.036,6.266l18.186,18.796L173.158,123.438z"
                            />
                            <path
                                d="M80.819,98.979c10.014,0,18.16-8.146,18.16-18.158c0-10.016-8.146-18.164-18.16-18.164
		c-10.015,0-18.162,8.148-18.162,18.164C62.657,90.834,70.805,98.979,80.819,98.979z M80.819,74.657c3.397,0,6.16,2.765,6.16,6.164
		c0,3.396-2.764,6.158-6.16,6.158c-3.398,0-6.162-2.763-6.162-6.158C74.657,77.422,77.421,74.657,80.819,74.657z"
                            />
                            <path
                                d="M140.867,68.414c-2.342-2.343-6.143-2.344-8.484,0l-63.968,63.967c-2.343,2.343-2.343,6.142,0,8.485
		c1.172,1.172,2.707,1.757,4.243,1.757c1.535,0,3.071-0.586,4.243-1.757l63.967-63.967C143.21,74.556,143.21,70.757,140.867,68.414z
		"
                            />
                            <path
                                d="M128.46,110.301c-10.013,0-18.158,8.146-18.158,18.158c0,10.016,8.146,18.164,18.158,18.164
		c10.016,0,18.164-8.148,18.164-18.164C146.624,118.447,138.476,110.301,128.46,110.301z M128.46,134.624
		c-3.395,0-6.158-2.765-6.158-6.164c0-3.395,2.763-6.158,6.158-6.158c3.398,0,6.164,2.763,6.164,6.158
		C134.624,131.858,131.859,134.624,128.46,134.624z"
                            />
                        </g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                    </svg>
                   
                    <div>{{ $t("header.discounts") }}</div>
                </router-link> -->

                <router-link class="navigation-profile-item" :to="{ name: 'profile', params: { view: 'сashback' } }" tag="div">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480.12 480.12" width="22" height="22" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings">
                            <path
                                d="M252.12,321.686v-11.842c-18.072-3.589-31.738-19.563-31.738-38.672c0-4.418,3.582-8,8-8s8,3.582,8,8 c0,12.92,10.512,23.431,23.432,23.431s23.431-10.511,23.431-23.431s-10.511-23.431-23.431-23.431 c-21.743,0-39.432-17.689-39.432-39.431c0-19.11,13.667-35.083,31.738-38.672v-11.952c0-4.418,3.582-8,8-8s8,3.582,8,8v12.081 c17.766,3.826,31.124,19.65,31.124,38.543c0,4.418-3.582,8-8,8s-8-3.582-8-8c0-12.92-10.511-23.431-23.431-23.431 s-23.432,10.511-23.432,23.431s10.512,23.431,23.432,23.431c21.742,0,39.431,17.689,39.431,39.431 c0,18.893-13.358,34.717-31.124,38.543v11.971c0,4.418-3.582,8-8,8S252.12,326.105,252.12,321.686z M415.299,84.256 c-85.038-85.04-218.183-85.568-304.171-6.521c-40.637,37.356-65.75,87.807-70.712,142.057c-0.402,4.4,2.838,8.293,7.238,8.696 c4.404,0.394,8.293-2.838,8.696-7.238c9.532-104.196,98.904-185.815,203.465-185.815c112.655,0,204.307,91.652,204.307,204.307 c0,147.3-151.903,245.766-285.147,187.432c54.72-59.526,22.2-153.167-53.311-170.116c-10.454-80.951,52.94-152.855,134.493-152.855 c74.772,0,135.604,60.832,135.604,135.604s-60.831,135.604-135.604,135.604c-4.418,0-8,3.582-8,8s3.582,8,8,8 c83.287,0,151.604-68.337,151.604-151.604c0-83.287-68.336-151.604-151.604-151.604c-88.634,0-159.756,77.232-150.853,166.56 c-29.529-1.749-57.822,9.084-78.866,30.128c-65.989,65.989-16.887,175.796,72.74,175.796c4.418,0,8-3.582,8-8s-3.582-8-8-8 c-48.003,0-87.056-39.053-87.056-87.056c0-53.359,47.784-94.289,100.606-86c0.334,0.08,0.676,0.134,1.022,0.17 c41.09,6.954,72.484,42.792,72.484,85.83c-0.001,40.805-27.092,62.009-31.12,66.59c-3.421,3.895-2.299,9.942,2.281,12.352 c141.998,74.197,318.726-32.609,318.726-196.831C480.12,181.275,457.1,126.056,415.299,84.256z M112.179,324.686H95.728l6.244-6.573 c3.043-3.204,2.914-8.267-0.29-11.31c-3.204-3.043-8.267-2.914-11.31,0.29l-19.011,20.012c-2.934,3.087-2.934,7.932,0,11.02 l19.011,20.012c3.044,3.205,8.109,3.332,11.31,0.29c3.204-3.043,3.333-8.106,0.291-11.31l-6.109-6.431h16.316 c12.682,0,23,10.318,23,23s-10.318,23-23,23H73.12c-4.418,0-8,3.582-8,8s3.582,8,8,8h39.059c21.505,0,39-17.495,39-39 S133.684,324.686,112.179,324.686z"
                            />
                        </svg>
                    </div>
                    <div>{{ $t("header.cashback") }}</div>
                </router-link>

                <router-link class="navigation-profile-item" :to="{ name: 'profile', params: { view: 'settings' } }" tag="div">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings">
                            <circle cx="12" cy="12" r="3"></circle>
                            <path
                                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                            ></path>
                        </svg>
                    </div>
                    <div>{{ $t("header.myProfile") }}</div>
                </router-link>

                <div class="navigation-profile-item" @click="logout">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="2 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                    </div>
                    <div>{{ $t("header.logout") }}</div>
                </div>
            </nav>
        </div>

        <div class="navigation-mobile" ref="mobileMenu" v-click-outside="closeMobileMenu" v-if="!isDesktop">
            <router-link class="navigation-item" :to="{ name: 'agreement' }" tag="div" @click.native="closeMobileMenu">
                {{ $t("header.termsOfUse") }}
            </router-link>
            <router-link class="navigation-item" :to="{ name: 'aml-kyc' }" tag="div" @click.native="closeMobileMenu">
                {{ $t("header.amlkyc") }}
            </router-link>
            <!-- <router-link class="navigation-item" :to="{ name: 'news' }" tag="div" @click.native="closeMobileMenu">
                {{ $t("header.news") }}
            </router-link> -->
            <!-- <router-link class="navigation-item" :to="{ name: 'faq' }" tag="div" @click.native="closeMobileMenu">
                {{ $t("header.faq") }}
            </router-link> -->
            <router-link class="navigation-item" :to="{ name: 'partners' }" tag="div" @click.native="closeMobileMenu">
                {{ $t("header.partnership") }}
            </router-link>
            <router-link class="navigation-item" :to="{ name: 'contacts' }" tag="div" @click.native="closeMobileMenu">
                {{ $t("header.contacts") }}
            </router-link>
            <router-link class="navigation-item" :to="{ name: 'acquiring' }" tag="div" @click.native="closeMobileMenu">
                {{ $t("header.acquiring") }}
            </router-link>
            <div class="navigation-sign" @click.stop="openAuth('signIn')" v-if="!isAuthenticated">
                <!-- <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="2 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                </div> -->
                <div class="sign-name">{{ $t("header.login") }}</div>
            </div>

            <div class="registr" @click.stop="changeView('signUp'), openAuth('signUp')">
                <my-button :value="$t('header.reg')" v-if="!isAuthenticated"></my-button>
            </div>
            <router-link class="navigation-user" :to="{ name: 'profile', params: { view: 'orders' } }" tag="div" :title="$t('header.myProfile')" @click.native="closeMobileMenu" v-if="isAuthenticated && isUser">
                <div class="avatar">
                    {{ firstChar }}
                </div>
                <div class="user-name">
                    {{ userName }}
                </div>
            </router-link>
        </div>

        <auth :view="authorization.view" @close-auth="closeAuth" @change-view="changeView" ref="auth"></auth>
    </header>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import loading from "./loading.vue";
import authorization from "./authorization.vue";
import button from "./ui/button.vue";
import LangSwithcer from "./LangSwithcer.vue";
// import discountIcon from "../assets/discount.png";

export default {
    components: {
        loading,
        auth: authorization,
        myButton: button,
        LangSwithcer
    },
    data() {
        return {
            mobileMenu: false,
            authorization: {
                open: false,
                view: "signIn"
            }
        };
    },
    watch: {},
    computed: {
        ...mapGetters(["isLoading", "isDesktop", "isAuthenticated", "user"]),

        isProfile() {
            return this.$route.name === "profile";
        },
        isUser() {
            return !!this.user;
        },
        userName() {
            return this.user.name || this.user.email;
        },
        firstChar() {
            return this.userName[0];
        }
    },
    methods: {
        ...mapMutations({
            logoutUser: "LOGOUT_USER"
        }),
        toggleMobileMenu() {
            if (this.mobileMenu) {
                this.$refs.mobileMenu.style.height = "0";
                this.mobileMenu = false;
            } else {
                this.$refs.mobileMenu.style.height = "auto";
                this.mobileMenu = true;
            }
        },
        closeMobileMenu() {
            if (this.mobileMenu) {
                this.mobileMenu = false;
                this.$refs.mobileMenu.style.height = "0";
            }
        },
        openAuth(view) {
            if (!this.authorization.open) {
                this.authorization.view = view;
                if (this.isDesktop) {
                    this.$refs.auth.$el.style.width = "420px";
                    this.$refs.auth.$el.style.height = "100%";
                } else {
                    this.$refs.auth.$el.style.width = "100%";
                    this.$refs.auth.$el.style.height = "100%";
                }
                this.authorization.open = true;
            }
        },
        closeAuth() {
            if (this.authorization.open) {
                this.$refs.auth.$el.style.width = "0px";
                this.$refs.auth.$el.style.height = "0%";
                this.authorization.open = false;
            }
        },
        changeView(view) {
            this.authorization.view = view;
        },
        logout() {
            this.logoutUser();
            this.$router.push("/");
        }
    }
};
</script>

<i18n>
    {
      "en": {
        "registration": "hello world!"
      },
      "ru": {
        "registration": "こんにちは、世界！"
      }
    }
    </i18n>

<style lang="scss" scoped>
.header-wrap {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    width: 100%;
    margin: 0 auto;
    height: 64px;
    z-index: 998;
    background-color: $white;
    box-shadow: 0 2px 2px -2px rgba(0, 0, 0, 0.32);
    transition: height 0.35s;
}

.header-wrap.is-profile {
    height: 128px;
}

.navigation {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-shrink: 0;
    align-items: center;
    height: 64px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
    overflow: hidden;
}

.navigation-profile-wrap {
    width: 100%;
    height: 64px;
    background-color: #ffffff;
    box-shadow: 0 -2px 2px -2px rgba(0, 0, 0, 0.32);
}

.navigation-profile {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    overflow-y: hidden;
    overflow-x: auto;
}

.navigation .logo {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    cursor: pointer;
    color: $grey-lg-text;
    font-family: Whitney, Proxima Nova, sans-serif, -apple-system, system-ui, BlinkMacSystemFont, “Segoe UI”, Roboto, “Helvetica Neue”, Arial, sans-serif;
    font-size: 28px;
    font-weight: 600;
    margin-right: 32px;
}

.navigation-item,
.navigation-profile-item {
    font-family: "Gotham Pro", -apple-system, system-ui, BlinkMacSystemFont, “Segoe UI”, Roboto, “Helvetica Neue”, Arial, sans-serif;
    position: relative;
    display: inline;
    text-align: center;
    height: 64px;
    line-height: 64px;
    font-size: 16px;
    color: $grey-lg-text;
    margin: 0 16px;
    cursor: pointer;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}

.navigation-item:hover:after,
.navigation-profile-item:hover:after {
    height: 2px;
    width: 100%;
    display: block;
    content: " ";
    bottom: 0;
    left: 0;
    position: absolute;
    background-color: $orange;
}

.navigation-item.router-link-active,
.navigation-profile-item.router-link-active {
    color: $orange;
}

.navigation-item.router-link-active:after,
.navigation-profile-item.router-link-active:after {
    height: 2px;
    width: 100%;
    display: block;
    content: "";
    bottom: 0;
    left: 0;
    position: absolute;
    background-color: $orange;
}

.navigation-profile-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    color: $grey-lg-text;
    line-height: inherit;
    padding-right: 2px;
}

.navigation-profile-item .icon {
    margin-right: 16px;
}

.navigation-sign {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    color: $grafit;
    border-radius: 4px;
}

.navigation-sign .icon {
    margin-right: 12px;
}

.navigation-user {
    cursor: pointer;
    position: relative;
    height: 64px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 16px;
}

.navigation-user:hover:after {
    height: 2px;
    width: 100%;
    display: block;
    content: " ";
    bottom: 0;
    left: 0;
    position: absolute;
    background-color: $orange;
}

.slang {
    margin: 0 0.5rem;
    font-size: 14px;
    font-weight: 400;
}

.flex {
    display: flex;
    text-align: end;
    align-items: center;
}

.sign-name {
    font-weight: 600;
}

.registr {
    margin-bottom: 1rem;
}

.navigation-user.router-link-active:after {
    height: 2px;
    width: 100%;
    display: block;
    content: "";
    bottom: 0;
    left: 0;
    position: absolute;
    background-color: $orange;
}

.navigation-user .avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 26px;
    width: 26px;
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    background-color: #565656;
    margin-right: 16px;
    border-radius: 50%;
}

.navigation-user .user-name {
    color: $grafit;
    font-weight: 500;
}

/* Mobile styles */
.navigation .icon-hamburger {
    cursor: pointer;
    color: $grey-lg-text;
}

.navigation-mobile {
    width: 100%;
    height: 0;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 64px;
    left: 0;
    background-color: #ffffff;
    padding: 0;
    box-shadow: 0 2px 2px -2px rgba(0, 0, 0, 0.32), 0 -2px 2px -2px rgba(0, 0, 0, 0.32);
    overflow-x: auto;
    overflow-y: hidden;
    transition: height 2.2s;
    z-index: 999;
}

.navigation-mobile .navigation-sign {
    flex-direction: row;
    margin: 8px 0 24px 0;
}

.navigation-mobile .navigation-user {
    margin: 0 16px 24px 16px;
}
</style>
